import { useSelector, useDispatch } from "react-redux";
import { setUser, initialState } from "store/auth/userSlice";
import { apiSignIn, apiSignUp } from "services/AuthService"; // apiSignOut
import { onSignInSuccess, onSignOutSuccess } from "store/auth/sessionSlice";
import appConfig from "configs/app.config";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import { useNavigate } from "react-router-dom";
import useQuery from "./useQuery";

function useAuth() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const query = useQuery();

 
  const { token, signedIn } = useSelector((state) => state.auth.session);
  const signIn = async (values) => {
    try {
      let resp = await apiSignIn(values);
      resp = resp.data;
      if (resp?.user) {
        if (resp?.user?.id && resp?.user?.token) {
          const { token } = resp.user;
          delete resp.user.token;
          dispatch(onSignInSuccess(token));
          dispatch(setUser(resp));

          if (resp.user.onboarding_completed && resp.user.company_id !== "-1") {
            if (resp?.user?.module_role == null) {
              navigate("/access-required");
            } else if (resp?.user?.module_role?.length > 0) {
              localStorage.setItem('user_id', JSON.stringify(resp.user.id));
              navigate("/home");
              return {
                status: "success",
                message: "",
              };
            }
          } else {
            navigate("/onboardProduct");
            return {
              status: "success",
              message: "",
            };
          }
          // navigate(
          //     redirectUrl
          //         ? redirectUrl
          //         : appConfig.authenticatedEntryPath
          // );

          return {
            status: "success",
            message: "",
          };
        }

        if (resp?.user?.error || resp?.user) {
          return {
            status: "failed",
            message: resp?.user?.message || resp.user.error,
          };
        }
      }
    } catch (errors) {
      return {
        status: "failed",
        message: `${errors.message}`,
      };
    }
  };

  const signUp = async (values) => {
    try {
      let resp = await apiSignUp(values);
      resp = resp.data;
      if (resp?.User) {
        return {
          status: "success",
          message: "",
        };
      }
      if (resp?.user) {
        return {
          status: "failed",
          message: resp?.user?.error || "Error occured. Try again.",
        };
      }
      // if (resp.data) {
      //     const { token } = resp.data;
      //     dispatch(onSignInSuccess(token));
      //     if (resp.data.user) {
      //         dispatch(
      //             setUser(
      //                 resp.data.user || {
      //                     avatar: "",
      //                     userName: "Anonymous",
      //                     authority: ["USER"],
      //                     email: "",
      //                 }
      //             )
      //         );
      //     }
      //     const redirectUrl = query.get(REDIRECT_URL_KEY);
      //     navigate(
      //         redirectUrl
      //             ? redirectUrl
      //             : appConfig.unAuthenticatedEntryPath
      //     );
      //     return {
      //         status: "success",
      //         message: "",
      //     };
      // }
    } catch (errors) {
      return {
        status: "failed",
        message: errors?.response?.data?.message,
      };
    }
  };

  const handleSignOut = () => {
    dispatch(onSignOutSuccess());
    dispatch(setUser(initialState));
    localStorage.removeItem("user_id")
    navigate(appConfig.unAuthenticatedEntryPath);
  };

  const signOut = async () => {
    // / await apiSignOut();
    handleSignOut();
  };

  return {
    authenticated: token && signedIn,
    signIn,
    signUp,
    signOut,
  };
}

export default useAuth;
